import { filter, uniq } from 'lodash';

import { CONTRACT_STATUSES } from '@/config/constants';
import { RENTALOBJECT_TYPES } from '@/config/constants';
import axios, {axios as axios_new} from '@/store/config';

export default {
  // state
  state: {
    contracts: [],
    namesOnDoors: [],
    invoices: []
  },
  // getters
  getters: {
    contracts: (state) => state.contracts,

    namesOnDoors: (state) => state.namesOnDoors,

    //Return if the user has a contract for an apartment or not
    hasApartment: (state) => {
      if (!Array.isArray(state.contracts)) return false;
      let ret = filter(state.contracts, (o) => o.rentalObjectType == RENTALOBJECT_TYPES.APARTMENT);
      return !!ret.length;
    },
    hasActiveOrComingContract(state) {
      if (!Array.isArray(state.contracts)) return false;
      const activeContract = filter(
        state.contracts,
        (c) => c.status != 'preliminarilyTerminated' && c.status != 'terminated',
      );

      return !!activeContract.length;
    },

    hasContract(state) {
      if (!Array.isArray(state.contracts)) return false;

      return !!state.contracts.length;
    },

    hasActiveResidentalContract(state) {
      if (!Array.isArray(state.contracts)) return false;

      const activeContract = filter(
        state.contracts,
        (c) => c.rentalObjectType === 'apartment' && c.status != CONTRACT_STATUSES.COMING && c.status != CONTRACT_STATUSES.TERMINATED && c.status != 'ceased' && c.status != CONTRACT_STATUSES.PRELIMINARILYTERMINATED,
      );

      return !!activeContract.length;
    },

    hasActiveOrTerminatedResidentalContract(state) {
      if (!Array.isArray(state.contracts)) return false;
      const activeContract = filter(
        state.contracts,
        (c) => c.rentalObjectType === 'apartment' && c.status != CONTRACT_STATUSES.COMING && c.status != 'ceased',
      );

      return !!activeContract.length;
    },

    hasActiveOrTerminatedContract(state) {
      if (!Array.isArray(state.contracts)) return false;

      const activeContract = filter(
        state.contracts,
        (c) => c.status != CONTRACT_STATUSES.COMING,
      );

      return !!activeContract.length;
    },

    hasParking: (state) => {
      let ret = filter(state.contracts, (o) => o.rentalObjectType == RENTALOBJECT_TYPES.PARKING);
      return !!ret.length;
    },
    hasStorage: (state) => {
      let ret = filter(state.contracts, (o) => o.rentalObjectType == RENTALOBJECT_TYPES.PREMISE);
      return !!ret.length;
    },

    //Return the the contracts by type
    getApartments: (state) => {
      let ret = filter(state.contracts, (o) => o.rentalObjectType == RENTALOBJECT_TYPES.APARTMENT);
      return ret;
    },
    getParkings: (state) => {
      let ret = filter(state.contracts, (o) => o.rentalObjectType == RENTALOBJECT_TYPES.PARKING);
      return ret;
    },
    getStorages: (state) => {
      let ret = filter(state.contracts, (o) => o.rentalObjectTypee == RENTALOBJECT_TYPES.PREMISE);
      return ret;
    },

    hasValidApartmentContract: (state, getters) => {
      if (!getters.hasApartment) return false;

      if (
        !getters.getApartments.some((apartment) => {
          return (
            apartment.status == CONTRACT_STATUSES.VALID ||
            apartment.status == CONTRACT_STATUSES.PRELIMINARILYTERMINATED ||
            apartment.status == CONTRACT_STATUSES.TERMINATED
          );
        })
      ) {
        return false;
      }
      return true;
    },

    hasValidParkingContract: (state, getters) => {
      if (!getters.hasParking) return false;

      if (
        !getters.getParkings.some((parking) => {
          return (
            parking.status == CONTRACT_STATUSES.VALID ||
            parking.status == CONTRACT_STATUSES.PRELIMINARILYTERMINATED ||
            parking.status == CONTRACT_STATUSES.TERMINATED
          );
        })
      ) {
        return false;
      }

      return true;
    },

    hasValidStorageContract: (state, getters) => {
      if (!getters.hasStorage) return false;

      if (
        !getters.getStorages.some((storage) => {
          return (
            storage.status == CONTRACT_STATUSES.VALID ||
            storage.status == CONTRACT_STATUSES.PRELIMINARILYTERMINATED ||
            storage.status == CONTRACT_STATUSES.TERMINATED
          );
        })
      ) {
        return false;
      }

      return true;
    },

    /**
     * Hämta ut alla momsområden man har bostad i.
     */
    getVatAreasForAllApartmentContracts: (state) => {
      return uniq(
        filter(state.contracts, (o) => o.rentalObjectType === RENTALOBJECT_TYPES.APARTMENT).map(
          (contract) => contract.rentalObject.vatArea,
        ),
      );
    },

    /**
     * Läs uppgifter om namn på dörr hämtat på kontraktsnummer
     */
    getNamesOnDoorByContractNumber: (state) => (ContractNumber) => {
      return state.namesOnDoors.find((nameondoor) => nameondoor.ContractNumber == ContractNumber);
    },

    /**
     * Hämta kontrakt på kontraktnummer
     */
    getContractByContractNumber: (state) => (contractNumber) => {
      return state.contracts.find((c) => c.contractNumber == contractNumber);
    },

    /**
     * Hämta kontrakt på kontraktnummer
     */
    getContractByRentalObjectCode: (state) => (rentalObjectCode) => {
      return state.contracts.find((c) => c.rentalObjectCode == rentalObjectCode);
    },

    /**
     * Hämta alla kontrakt av en viss sort, t.ex. ["apartment"]
     */
    getContractsByRentalObjectTypes: (state) => (rentalObjectTypes) => {
      rentalObjectTypes = Array.isArray(rentalObjectTypes)
        ? rentalObjectTypes
        : [rentalObjectTypes];

      if (rentalObjectTypes == "laundryroom") rentalObjectTypes = "apartment";
      return state.contracts.filter((contract) => contract.rentalObjectType == rentalObjectTypes);
    },

    /**
     * Retunerar alla typer av kontrakt
     */
    getContracts: (state) => {
      return state.contracts;
    },
  },

  // actions
  actions: {
    /**
     * Hämta enskilt kontrakt på kontraktnummer och uppdatera samlingen
     */
    fetchContractByContractNumber({ dispatch, commit }, contractNumber) {
      return new Promise((resolve, reject) => {
        this.cache.dispatch('fetchContracts').finally(() => {
          const contract = this.getters.contracts.find((c) => c.contractNumber == contractNumber);

          if (contract) return resolve(contract);

          return reject();
        });
      });

      //  return state.contracts.find((contract) => contract.contractNumber == contractNumber);
    },

    /**
     * Hämta alla "mina" kontrakt
     */
    fetchContracts({ dispatch, commit, rootState }) {
      return new Promise((resolve, reject) => {
        axios_new
          .get('/applicants/rentcontracts')
          .then((response) => {
            let contracts = JSON.parse(JSON.stringify(response.data));
            // Define sort order for rentalObjectType
            const typeOrder = {
              apartment: 0,
              parking: 1,
              premise: 2,
            };

            // Sort by type first, then by status
            let contractsSorted = contracts.sort((a, b) => {
              // First, sort by rentalObjectType
              const typeA = typeOrder[a.rentalObjectType] ?? 999;
              const typeB = typeOrder[b.rentalObjectType] ?? 999;

              if (typeA !== typeB) {
                return typeA - typeB;
              }

              // If types are equal, sort by status ('valid' first)
              if (a.status === CONTRACT_STATUSES.VALID && b.status !== CONTRACT_STATUSES.VALID) return -1;
              if (a.status !== CONTRACT_STATUSES.VALID && b.status === CONTRACT_STATUSES.VALID) return 1;

              return 0;
            });
            commit('setContracts', contractsSorted);
            resolve(contractsSorted);

            if (response.data.length == 0) {
              resolve(true);
            }
          })
          .catch(function (error) {
            reject(error); // skickar vidare uppåt

            // //If the user has no contracts resolve as false
            // if(error.response.status === 404) {
            //   resolve(false);
            // }
          });
      });
    },

    fetchNamesOnDoorByContractNumber({ state, commit }, contractNumber) {
      return new Promise((resolve, reject) => {
        axios
          .get('/rentcontracts/' + contractNumber + '/nameOnDoor')
          .then((response) => {
            const namesOnDoors = {
              ContractNumber: response.data.ContractNumber,
              NameOnDoor: response.data.NameOnDoor,
              intercomes: [],
            };

            if (response.data.NameOnIntercom) {
              console.log("response.data.NameOnIntercom",response.data.NameOnIntercom)
              /**
               * Gör om "namn1/namn2/namn3" och "nummer1/nummer2/nummer3"
               * till [{name:"namn1", "number":"nummer1"}, .... ]
               */
              const names = response.data.NameOnIntercom.split('/');
              const numbers = response.data.NumberOnIntercom.split('/');
              for (let i = 0; i < names.length; i++) {
                namesOnDoors.intercomes.push({ name: names[i], number: numbers[i] });
              }
            }

            commit('pushNamesOnDoors', namesOnDoors);
            return resolve(namesOnDoors);
          })
          .catch((error) => {
            /**
             * Har man sparat med tomt namn får man inget data från servern,
             * men objektet måste finnas för att få spara nytt namn ändå.
             *
             * Med denna fix får man spara fast man haft ett tomt namn innan.
             */
            if (error.response && error.response.status == 404) {
              const namesOnDoor = {
                ContractNumber: contractNumber,
                NameOnDoor: '',
                intercomes: [],
              };
              commit('pushNamesOnDoors', namesOnDoor);

              return resolve(namesOnDoor);
            }

            return reject(error);
          });
      });
    },

    /**
     * Spara namn på dörr på ett visst kontrakt
     */
    saveNamesOnDoor({ state, commit }, data) {

      return new Promise((resolve, reject) => {
        const intercomNames = data.intercomes.length > 0 ? data.intercomes.map((intercome) => intercome.name).join('/') : null;
        const intercomNumbers = data.intercomes.length > 0 ? data.intercomes.map((intercome) => intercome.number).join('/') : null;

        const formatedData = {
          NameOnDoor: data.NameOnDoor,
          ContractNumber: data.ContractNumber,

          // Gör om [{name:"namn1", "number":"nummer1"}, .... ] till "namn1/namn2/namn3"  "nummer1/nummer2/nummer3" igen
          NameOnIntercom: intercomNames,
          NumberOnIntercom: intercomNumbers,
        };

        axios
          .post('/rentcontracts/' + data.ContractNumber + '/nameondoor', formatedData)
          .then((response) => {
            const namesOnDoors = {
              NameOnDoor: response.data.NameOnDoor,
              ContractNumber: response.data.ContractNumber,
              intercomes: [],
            };

            /**
             * Gör om "namn1/namn2/namn3" och "nummer1/nummer2/nummer3"
             * till [{name:"namn1", "number":"nummer1"}, .... ]
             */
            if (response.data.NameOnIntercom) {
              const names = response.data.NameOnIntercom.split('/');
              const numbers = response.data.NumberOnIntercom.split('/');
              for (let i = 0; i < names.length; i++) {
                namesOnDoors.intercomes.push({ name: names[i], number: numbers[i] });
              }
            }

            commit('pushNamesOnDoors', namesOnDoors);
            resolve(namesOnDoors);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    /**
     * Säg upp kontrakt.
     */
    async createTerminationRequest({ dispatch }, request) {
      /**
       * Det finns ingen endpoint som tar emot e-postadress när man säger upp ett kontrakt,
       * därför måste först e-postadressen ändras, och sedan själva uppsägningen göras
       */

      try {
        const profile = await dispatch('fetchProfile');

        const needsUpdate =
          profile.email !== request.email || profile.phoneMobile !== request.phoneMobile;

        if (needsUpdate) {
          await dispatch('saveProfile', {
            ...profile,
            email: request.email,
            phoneMobile: request.phoneMobile,
          });
        }

        await axios.put(
          `/rentcontracts/${request.contractNumber}/terminationRequest?desiredMoveDate=${request.desiredMoveDate}`,
          request
        );

        await Promise.all([
          dispatch('fetchProfile'),
          dispatch('fetchContracts')
        ]);
        return true; // Optional: resolve with a success flag or data
      } catch (error) {
        console.error('Termination request failed:', error);
        throw error; // So the caller can handle it
      }
    }
  },

  // mutations
  mutations: {
    setContracts(state, contracts) {
      state.contracts = contracts;
    },

    /**
     * Lägg till "namesondoors" i samlingen.
     * Ersätter eventuell tidigare version
     */
    pushNamesOnDoors(state, data) {
      state.namesOnDoors = [
        ...state.namesOnDoors.filter((n) => n.ContractNumber != data.ContractNumber),
        data,
      ];
    },
  },
};
